


















import { Component, Vue } from 'vue-property-decorator';
import { ICapItem } from '@/models/course-intro';

export default class CourseIntro extends Vue {
  public capItems: ICapItem[] = [{
    key: 'course',
    iconSrc: require('@/assets/iconcourse.svg'),
    caption: '• 课程：支持多门课程管理，涵盖课程作业、课程成员、课程讨论等模块',
  }, {
    key: 'iconjudge',
    iconSrc: require('@/assets/iconjudge.svg'),
    caption: '• 评测：支持C、C++在线评测，抄袭检查，数据统计及批量导出',
  }, {
    key: 'iconlibrary',
    iconSrc: require('@/assets/iconlibrary.svg'),
    caption: '• 题库：通过添加原子题目、创建题库、关联课程等实现老师/TA出题功能',
  }];
}
